var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _g5, _path0, _path1, _g6, _path10, _path11, _g7, _path12, _g8, _path13, _g9, _path14, _path15, _g0, _path16, _path17, _g1, _path18, _path19, _g10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogostatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 35,
    viewBox: "0 0 21 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3032 8.29542C1.3032 8.29542 8.55958 7.79824 8.60898 15.6001C0.806863 15.5506 1.3032 8.29542 1.3032 8.29542Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4080_11736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 7,
    width: 10,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.859375 7.67188H9.19601V16.0969H0.859375V7.67188Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4080_11736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.04114 16.0323L8.61443 16.03C6.09794 16.0131 4.14067 15.2719 2.79653 13.8231C0.692154 11.5566 0.88193 8.40704 0.890913 8.27431L0.915617 7.90874L1.28282 7.88287C1.28282 7.88287 1.38613 7.875 1.56804 7.875C2.80776 7.875 8.99174 8.24844 9.0389 15.6048L9.04114 16.0323Z",
    fill: "url(#paint0_linear_4080_11736)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4080_11736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 7,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90625 0H12.9431V11.6971H6.90625V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4080_11736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.95153 11.5515L9.65171 11.2478C7.88309 9.45708 7.02405 7.54824 7.09817 5.57417C7.21383 2.48313 9.57423 0.39095 9.67529 0.304338L9.95153 0.0625L10.2289 0.304338C10.33 0.39095 12.6904 2.48313 12.806 5.57417C12.8801 7.54824 12.0211 9.45708 10.2525 11.2478L9.95153 11.5515Z",
    fill: "url(#paint1_linear_4080_11736)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.798 8.29542C18.798 8.29542 11.5427 7.79824 11.4922 15.6001C19.2954 15.5506 18.798 8.29542 18.798 8.29542Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4080_11736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 7,
    width: 10,
    height: 10
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9141 7.67188H19.2507V16.0969H10.9141V7.67188Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4080_11736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0625 16.0323L11.0659 15.6048C11.113 8.24844 17.297 7.875 18.5356 7.875C18.7186 7.875 18.822 7.88287 18.822 7.88287L19.188 7.90874L19.2139 8.27431C19.2228 8.40704 19.4126 11.5554 17.3082 13.8231C15.9652 15.2719 14.0068 16.0131 11.4892 16.03L11.0625 16.0323Z",
    fill: "url(#paint2_linear_4080_11736)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4080_11736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 12,
    width: 20,
    height: 23
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.289062 12.4688H19.837V35.0036H0.289062V12.4688Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4080_11736)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4080_11736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 12,
    width: 20,
    height: 24
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5749 35.0057V12.4889C13.5086 12.4844 13.4435 12.4844 13.3772 12.4844H6.76543V35.0057H13.5749ZM5.07093 35.0057H6.76543V12.4889H6.72837C3.98842 12.4889 1.5831 14.7284 1.38547 17.4629L0.459051 30.0373C0.255801 32.7662 2.3321 35.0057 5.07093 35.0057ZM15.0336 35.0057C17.7735 35.0057 19.8487 32.7662 19.6466 30.0317L18.719 17.4584C18.5214 14.7903 16.225 12.5935 13.5704 12.4889V35.0057H15.0336Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4080_11736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.663 35.0114H0.460938V12.4766H19.663V35.0114Z",
    fill: "#FFDE59"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_4080_11736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 9,
    height: 10
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.8984H8.75212V20.6654H0V11.8984Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_4080_11736)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_4080_11736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 9,
    height: 10
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37606 11.8906C1.95951 11.8906 0 13.8523 0 16.2741C0 18.6947 1.95951 20.6576 4.37606 20.6576C6.79261 20.6576 8.75212 18.6947 8.75212 16.2741C8.75212 13.8523 6.79261 11.8906 4.37606 11.8906Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_4080_11736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.8906H8.75212V20.6576H0V11.8906Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_4080_11736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 13,
    width: 7,
    height: 6
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64062 13.5234H7.09807V18.9912H1.64062V13.5234Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_4080_11736)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_4080_11736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 13,
    width: 7,
    height: 6
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37716 13.5312C2.87019 13.5312 1.64844 14.7551 1.64844 16.2657C1.64844 17.7752 2.87019 18.999 4.37716 18.999C5.88413 18.999 7.10588 17.7752 7.10588 16.2657C7.10588 14.7551 5.88413 13.5312 4.37716 13.5312Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_4080_11736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.64844 13.5312H7.10588V18.999H1.64844V13.5312Z",
    fill: "#0E0B26"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_4080_11736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 14,
    width: 3,
    height: 3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07031 14.4688H6.17132V16.5733H4.07031V14.4688Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_4080_11736)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_4080_11736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 14,
    width: 3,
    height: 3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.137 14.4844C4.55645 14.4844 4.08594 14.9557 4.08594 15.5361C4.08594 16.1176 4.55645 16.5889 5.137 16.5889C5.71643 16.5889 6.18694 16.1176 6.18694 15.5361C6.18694 14.9557 5.71643 14.4844 5.137 14.4844Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_4080_11736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.08594 14.4844H6.18694V16.5889H4.08594V14.4844Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_4080_11736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 23,
    width: 8,
    height: 8
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97656 23.3594H13.1684V30.3986H6.97656V23.3594Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_4080_11736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0769 32.2422C9.87368 32.2422 9.67267 32.214 9.47391 32.1567C9.27403 32.1004 9.08089 32.0161 8.89336 31.9047C8.70583 31.7922 8.52728 31.6561 8.35884 31.4941C8.18928 31.3322 8.03319 31.1477 7.88946 30.9419C7.74572 30.7349 7.61771 30.511 7.50541 30.2681C7.392 30.0262 7.29655 29.7698 7.21907 29.4998C7.14159 29.231 7.08319 28.9532 7.04277 28.6674C7.00346 28.3806 6.98438 28.0927 6.98438 27.8002C6.98438 27.5089 7.00346 27.2198 7.04277 26.9341C7.08319 26.6484 7.14159 26.3705 7.21907 26.1006C7.29655 25.8318 7.392 25.5753 7.50541 25.3335C7.61771 25.0905 7.74572 24.8666 7.88946 24.6597C8.03319 24.4538 8.18928 24.2694 8.35884 24.1074C8.52728 23.9454 8.70583 23.8093 8.89336 23.6968C9.08089 23.5855 9.27403 23.5011 9.47391 23.4449C9.67267 23.3875 9.87368 23.3594 10.0769 23.3594C10.2802 23.3594 10.4812 23.3875 10.6799 23.4449C10.8798 23.5011 11.073 23.5855 11.2605 23.6968C11.448 23.8093 11.6266 23.9454 11.795 24.1074C11.9646 24.2694 12.1207 24.4538 12.2644 24.6597C12.4081 24.8666 12.5361 25.0905 12.6484 25.3335C12.7619 25.5753 12.8573 25.8318 12.9348 26.1006C13.0123 26.3705 13.0707 26.6484 13.1111 26.9341C13.1504 27.2198 13.1695 27.5089 13.1695 27.8002C13.1695 28.0927 13.1504 28.3806 13.1111 28.6674C13.0707 28.9532 13.0123 29.231 12.9348 29.4998C12.8573 29.7698 12.7619 30.0262 12.6484 30.2681C12.5361 30.511 12.4081 30.7349 12.2644 30.9419C12.1207 31.1477 11.9646 31.3322 11.795 31.4941C11.6266 31.6561 11.448 31.7922 11.2605 31.9047C11.073 32.0161 10.8798 32.1004 10.6799 32.1567C10.4812 32.214 10.2802 32.2422 10.0769 32.2422Z",
    fill: "#0E0B26"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_4080_11736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 28,
    width: 6,
    height: 4
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33594 28.0469H12.6901V31.9017H7.33594V28.0469Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_4080_11736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6901 29.9737C12.6901 30.0997 12.6721 30.2245 12.6384 30.3494C12.6036 30.4731 12.5531 30.5935 12.4857 30.7105C12.4183 30.8275 12.3363 30.9377 12.2387 31.0434C12.141 31.148 12.0298 31.2459 11.9051 31.3348C11.7816 31.4247 11.6457 31.5046 11.4998 31.5743C11.3538 31.6452 11.1999 31.7037 11.0371 31.7521C10.8743 31.8004 10.707 31.8376 10.5352 31.8623C10.3622 31.887 10.1882 31.8994 10.013 31.8994C9.8367 31.8994 9.66265 31.887 9.49084 31.8623C9.31791 31.8376 9.15059 31.8004 8.98777 31.7521C8.82607 31.7037 8.6711 31.6452 8.52512 31.5743C8.37914 31.5046 8.24327 31.4247 8.11974 31.3348C7.9951 31.2459 7.88393 31.148 7.78623 31.0434C7.68854 30.9377 7.60656 30.8275 7.53919 30.7105C7.47181 30.5935 7.42128 30.4731 7.38647 30.3494C7.35278 30.2245 7.33594 30.0997 7.33594 29.9737C7.33594 29.8466 7.35278 29.7217 7.38647 29.5969C7.42128 29.4732 7.47181 29.3528 7.53919 29.2358C7.60656 29.1188 7.68854 29.0086 7.78623 28.9029C7.88393 28.7983 7.9951 28.7004 8.11974 28.6115C8.24327 28.5216 8.37914 28.4417 8.52512 28.372C8.6711 28.3011 8.82607 28.2426 8.98777 28.1942C9.15059 28.1459 9.31791 28.1087 9.49084 28.084C9.66265 28.0592 9.8367 28.0469 10.013 28.0469C10.1882 28.0469 10.3622 28.0592 10.5352 28.084C10.707 28.1087 10.8743 28.1459 11.0371 28.1942C11.1999 28.2426 11.3538 28.3011 11.4998 28.372C11.6457 28.4417 11.7816 28.5216 11.9051 28.6115C12.0298 28.7004 12.141 28.7983 12.2387 28.9029C12.3363 29.0086 12.4183 29.1188 12.4857 29.2358C12.5531 29.3528 12.6036 29.4732 12.6384 29.5969C12.6721 29.7217 12.6901 29.8466 12.6901 29.9737Z",
    fill: "#FA5B5B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_4080_11736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 10,
    height: 10
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3359 11.8984H20.0881V20.6654H11.3359V11.8984Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_4080_11736)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_4080_11736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 10,
    height: 10
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6964 11.8828C13.2787 11.8828 11.3203 13.8445 11.3203 16.2663C11.3203 18.6869 13.2787 20.6497 15.6964 20.6497C18.1129 20.6497 20.0724 18.6869 20.0724 16.2663C20.0724 13.8445 18.1129 11.8828 15.6964 11.8828Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_4080_11736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3203 11.8828H20.0724V20.6497H11.3203V11.8828Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_4080_11736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 13,
    width: 7,
    height: 6
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9766 13.5234H18.4351V18.9912H12.9766V13.5234Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_4080_11736)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_4080_11736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 13,
    width: 7,
    height: 6
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6986 13.5312C14.1905 13.5312 12.9688 14.7551 12.9688 16.2657C12.9688 17.7752 14.1905 18.999 15.6986 18.999C17.2056 18.999 18.4273 17.7752 18.4273 16.2657C18.4273 14.7551 17.2056 13.5312 15.6986 13.5312Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_4080_11736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9688 13.5312H18.4273V18.999H12.9688V13.5312Z",
    fill: "#0E0B26"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_4080_11736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 14,
    width: 3,
    height: 3
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.4688H17.601V16.5733H15.5V14.4688Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_4080_11736)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_4080_11736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 14,
    width: 3,
    height: 3
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5656 14.4844C15.985 14.4844 15.5156 14.9557 15.5156 15.5361C15.5156 16.1176 15.985 16.5889 16.5656 16.5889C17.1461 16.5889 17.6166 16.1176 17.6166 15.5361C17.6166 14.9557 17.1461 14.4844 16.5656 14.4844Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_4080_11736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5156 14.4844H17.6166V16.5889H15.5156V14.4844Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4080_11736",
    x1: 4.96198,
    y1: 7.875,
    x2: 4.96198,
    y2: 16.0323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4080_11736",
    x1: 9.95209,
    y1: 0.0625,
    x2: 9.95209,
    y2: 11.5515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4080_11736",
    x1: 15.1422,
    y1: 7.875,
    x2: 15.1422,
    y2: 16.0323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogostatic);
export default __webpack_public_path__ + "static/media/logostatic.921b0c8903878712ced30fd5f86eb697.svg";
export { ForwardRef as ReactComponent };